import type { Observable } from 'rxjs';
import { distinctUntilChanged, map } from 'rxjs/operators';
import { filterOperations } from '@ardoq/core';
import { isEqual } from '@ardoq/common-helpers';
import type { FilterInterfaceFilter, FormattingFilter } from '@ardoq/api-types';
import { formattingAndLabelRules$ } from './formattingAndLabelRules$';

export const formattingFilters$: Observable<
  (FormattingFilter | FilterInterfaceFilter)[]
> = formattingAndLabelRules$.pipe(
  map(({ rules }) => rules.filter(filterOperations.isStrictlyFormattingFilter)),
  distinctUntilChanged(isEqual)
);
